// -----------------------------------------------------------------------------
// Data: HOT2000 user defined layer lookup tables (emissions/storage kg per m² unless perUnit says m²/mm)
// -----------------------------------------------------------------------------

export const UDEF_CONTINUOUS_MEDIUM_MATERIAL_TYPE = {
    0: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    1: { emissions: 0.394241, storage: 0.031785, emissionGrade: "B", storageGrade: "D", perUnit: "m2/mm" },
    2: { emissions: 0.226, storage: 1.773, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    3: { emissions: 0.65848, storage: 0.73232, emissionGrade: "C", storageGrade: "B", perUnit: "m2/mm" },
    4: { emissions: 0.226, storage: 1.773, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    5: { emissions: 0.16131, storage: 0.177732, emissionGrade: "A", storageGrade: "C", perUnit: "m2/mm" },
    6: { emissions: 0.16131, storage: 0.177732, emissionGrade: "A", storageGrade: "C", perUnit: "m2/mm" },
    7: { emissions: 0.189202, storage: 1.500637, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    8: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    9: { emissions: 0.16131, storage: 0.177732, emissionGrade: "A", storageGrade: "C", perUnit: "m2/mm" },
    10: { emissions: 0.394241, storage: 0.031785, emissionGrade: "B", storageGrade: "D", perUnit: "m2/mm" },
    11: { emissions: 0.46322, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    12: { emissions: 0.46322, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    13: { emissions: 0.46322, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    14: { emissions: 0.27367, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    15: { emissions: 0.27367, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    16: { emissions: 0.27367, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    17: { emissions: 0.27394, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    18: { emissions: 0.27394, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    19: { emissions: 0.27394, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    20: { emissions: 0.27394, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    21: { emissions: 0.27394, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    22: { emissions: 0.27394, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    23: { emissions: 0.157015, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    24: { emissions: 0.09811, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    25: { emissions: 1.574803, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    26: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    27: { emissions: 0.27394, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    28: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    29: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    30: { emissions: 0.0, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    31: { emissions: 0.0, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    32: { emissions: 0.0, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    33: { emissions: 0.031658, storage: 1.20015, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    34: { emissions: 0.042843, storage: 1.624146, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    35: { emissions: 0.65848, storage: 0.73232, emissionGrade: "B", storageGrade: "B", perUnit: "m2/mm" },
    36: { emissions: 0.16131, storage: 0.177732, emissionGrade: "A", storageGrade: "C", perUnit: "m2/mm" },
    37: { emissions: 0.471, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    37: { emissions: 1.392412, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    38: { emissions: 0.524169, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    38: { emissions: 1.437017, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    39: { emissions: 0.116218, storage: 1.683779, emissionGrade: "A", storageGrade: "B", perUnit: "m2/mm" },
    40: { emissions: 0.394241, storage: 0.031785, emissionGrade: "D", storageGrade: "B", perUnit: "m2/mm" },
    41: { emissions: 0.919896, storage: 0.074165, emissionGrade: "D", storageGrade: "B", perUnit: "m2/mm" },
    42: { emissions: 1.209091, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
    43: { emissions: 1.209091, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    44: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    45: { emissions: 0.52256, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    46: { emissions: 0.042874, storage: 1.625346, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    47: { emissions: 2.679775, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    47: { emissions: 0.456183, storage: 0.529182, emissionGrade: "C-", storageGrade: "A+", perUnit: "m2/mm" },
    48: { emissions: 1.608358, storage: 0.14459, emissionGrade: "D", storageGrade: "A+", perUnit: "m2/mm" },
    49: { emissions: 0.033563, storage: 1.272345, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    50: { emissions: 0.042733, storage: 1.62, emissionGrade: "A", storageGrade: "A+", perUnit: "m2/mm" },
    51: { emissions: 0.0341, storage: 0.0, emissionGrade: "A", storageGrade: "N/A", perUnit: "m2/mm" },
};

//Used for both continuous insulation and cavity insulation
export const UDEF_INSULATION_MATERIAL_TYPE = {
    0: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    1: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    2: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    3: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    4: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    5: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    6: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    7: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    8: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    9: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    10: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    11: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    12: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    13: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    14: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    15: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    16: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    17: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    18: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    19: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    20: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    21: { emissions: 0.020633, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    22: { emissions: 0.017348, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    23: { emissions: 0.035383, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
    24: { emissions: 0.014035, storage: 0.061261, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    25: { emissions: 0.014861, storage: 0.064864, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    26: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    27: { emissions: 0.013669, storage: 0.050693, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    28: { emissions: 0.01, storage: 0.037087, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    29: { emissions: 0.00503, storage: 0.018653, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    30: { emissions: 0.013071, storage: 0.117209, emissionGrade: "C", storageGrade: "A+", perUnit: "m2/mm" },
    31: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    32: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    33: { emissions: 0.149086, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    34: { emissions: 0.152068, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    35: { emissions: 0.065664, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    36: { emissions: 0.095401, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    37: { emissions: 0.170509, storage: 0.0, emissionGrade: "D", storageGrade: "N/A", perUnit: "m2/mm" },
    38: { emissions: 0.142462, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    39: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    40: { emissions: 0.16131, storage: 0.177732, emissionGrade: "D", storageGrade: "A+", perUnit: "m2/mm" },
    41: { emissions: 0.074349, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    42: { emissions: 0.085118, storage: 0.252021, emissionGrade: "C-", storageGrade: "A+", perUnit: "m2/mm" },
    43: { emissions: 0.122168, storage: 0.0, emissionGrade: "C-", storageGrade: "N/A", perUnit: "m2/mm" },
    44: { emissions: 0.0078, storage: 0.058228, emissionGrade: "A+", storageGrade: "A+", perUnit: "m2/mm" },
    45: { emissions: 0.017348, storage: 0.0, emissionGrade: "B", storageGrade: "N/A", perUnit: "m2/mm" },
    46: { emissions: null, storage: null, emissionGrade: "N/A", storageGrade: "N/A", perUnit: "m2/mm" },
    47: { emissions: 0.035446, storage: 0.0, emissionGrade: "C", storageGrade: "N/A", perUnit: "m2/mm" },
};

export const UDEF_UNDEFINED_MATERIAL_TYPE = {
    emissions: null,
    storage: null,
    emissionGrade: "N/A",
    storageGrade: "N/A",
    perUnit: "m2/mm",
};

/** udefWindowOverallGlazingType ids that use the `double` column in {@link UDEF_WINDOW_EMBODIED_BY_GLAZING_AND_FRAME}. */
export const WINDOW_DOUBLE_GLAZING_TYPES = ["1", "4", "5", "6"];

/** udefWindowOverallGlazingType ids that use the `triple` column. */
export const WINDOW_TRIPLE_GLAZING_TYPES = ["2", "3"];

/**
 * Nested: first key = glazing bucket (`double` | `triple`), second = frame material code (string).
 * Comments in UI: 0/1 aluminum, 2 wood, 3 aluminum-clad wood, 4/5 vinyl, 6 fibreglass.
 */
export const UDEF_WINDOW_EMBODIED_BY_GLAZING_AND_FRAME = {
    double: {
        0: { emissions: 99.0, storage: 0 },
        1: { emissions: 99.0, storage: 0 },
        2: { emissions: 72.0, storage: 16.4286 },
        3: { emissions: 99.0, storage: 8.1405 },
        4: { emissions: 86.0, storage: 0.0 },
        5: { emissions: 86.0, storage: 0.0 },
        6: { emissions: 114.0, storage: 0.0 },
    },
    triple: {
        0: { emissions: 112.0, storage: 0.0 },
        1: { emissions: 112.0, storage: 0.0 },
        2: { emissions: 85.0, storage: 16.4286 },
        3: { emissions: 112.0, storage: 8.1405 },
        4: { emissions: 99.0, storage: 0.0 },
        5: { emissions: 99.0, storage: 0.0 },
        6: { emissions: 127.0, storage: 0.0 },
    },
};

/** [maxKgPerM2, grade] — first tier where emissions ≤ cap wins; bands ~5.5 kg/m² wide from collected window data. */
export const UDEF_WINDOW_EMISSION_TIERS = [
    [72.0001, "A+"],
    [77.5, "A"],
    [83.0, "A-"],
    [88.5, "B+"],
    [94.0, "B"],
    [99.5, "B-"],
    [105.0, "C+"],
    [110.5, "C"],
    [116.0, "C-"],
];

export const STEEL_EMBODIED_CARBON_PER_KG_STEEL = 2.38; // kgCO2 / kg steel
export const STEEL_EMBODIED_CARBON_PER_M_STEEL_STUD = 7.0698; // kgCO2 / m steel stud, averaged from MCE2
export const STANDARD_STEEL_STUD_CROSS_SECTION_AREA = 0.00037984; // m2 (2x6 stud, 16 gauge)

//Calculated for 2x6" steel studs.
export const STEEL_FRAMING_FRACTIONS = {
    400: 3.79, //16" spacing, 3.79m /m2 of wall area is steel
    600: 2.97, //24" spacing, 2.97m /m2 of wall area is steel
};
//Calculated for 2x6" steel studs and the data points above.
export const getSteelFramingLengthPerM2 = (spacing) => -0.0041 * spacing + 5.43; // accepts spacing in mm and returns steel framing length per m2 of wall area in meters

//Steel embodied carbon numbers (2x6 steel stud), all 16 gauge
// 2.38 kgCO2 / kg steel
// Steel stud weight per length => 2.604 kg/m
// MCE2:
// @ 24" spacing: 2.97m /m2 of wall area is steel
// @ 16" spacing: 3.79m /m2 of wall area is steel

// Steel stud kgCO2/m of 2x6 stud
// 6.20
// 6.46
// 8.55

// *********************************************************************************
// =>       <= Width of steel frame    _V_  Thickness of steel frame
//  |=======|
//  | |   |_|
//  | |
//  | |
//  | |
//  | |
//  | |
//  | |    _    _V_
//  | |   | |   ___  Lip length
//  |=======|    ^                      ___
// => <= Gauge of steel frame           ^
//
// All lip lengths assumed to be 1/2" (12.7mm)
//
// *********************************************************************************

const getSteelFrameCrossSectionArea = (width, thickness, gauge, lipLength = 12.7) => {
    return (gauge * (2 * width + thickness + 2 * lipLength)) / 1000000; //simplified to area in m2
};
